import { request } from './client';
import type { SquareRequest, CreateSquareRequestInput, CreateSquareRequestResponse, ApproveSquareRequestInput, DenySquareRequestInput, AssignSquaresInput } from '../types';

export const squareRequestsApi = {
  async create(boardId: string, input: CreateSquareRequestInput): Promise<CreateSquareRequestResponse> {
    return request<CreateSquareRequestResponse>(`/api/squareup/boards/${boardId}/requests`, {
      method: 'POST',
      body: input,
    });
  },

  async list(boardId: string, status?: string): Promise<SquareRequest[]> {
    const params = status ? `?status=${status}` : '';
    return request<SquareRequest[]>(`/api/squareup/boards/${boardId}/requests${params}`);
  },

  async getMyRequests(boardId: string): Promise<SquareRequest[]> {
    const result = await request<SquareRequest[]>(`/api/squareup/boards/${boardId}/requests/me`);
    return result || [];
  },

  async approve(boardId: string, requestId: string, input?: ApproveSquareRequestInput): Promise<SquareRequest> {
    return request<SquareRequest>(`/api/squareup/boards/${boardId}/requests/${requestId}/approve`, {
      method: 'POST',
      body: input || {},
    });
  },

  async deny(boardId: string, requestId: string, input?: DenySquareRequestInput): Promise<SquareRequest> {
    return request<SquareRequest>(`/api/squareup/boards/${boardId}/requests/${requestId}/deny`, {
      method: 'POST',
      body: input || {},
    });
  },

  async approveAll(boardId: string): Promise<{ approvedCount: number; failedCount: number; requests: SquareRequest[] }> {
    return request<{ approvedCount: number; failedCount: number; requests: SquareRequest[] }>(`/api/squareup/boards/${boardId}/requests/approve-all`, {
      method: 'POST',
    });
  },

  async delete(boardId: string, requestId: string): Promise<void> {
    return request<void>(`/api/squareup/boards/${boardId}/requests/${requestId}`, {
      method: 'DELETE',
    });
  },

  async assignSquares(boardId: string, input: AssignSquaresInput): Promise<SquareRequest> {
    return request<SquareRequest>(`/api/squareup/boards/${boardId}/requests/assign`, {
      method: 'POST',
      body: input,
    });
  },
};
